import axios from 'axios';
import config from '../../config';

const baseUrl = config.baseUrl;
const endpoint = '/api/poaCheckFile/upsert'; 

// Servicio para cargar un archivo y su información adicional al backend
export const enviarHistorico = async (data) => {
  try {
    const response = await axios.post(`${baseUrl}${endpoint}`, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return response.data;
  } catch (error) {
    console.error('Error al enviar histórico:', error);
    throw error;
  }
};
